import { SchoolSpaceType } from "../../../generated/graphql";
import { schoolSpaceType } from "../SchoolSubscription/maps";
import { Autocomplete } from "@material-ui/lab";
import { StyledTextField } from "../Style";

interface SchoolSpaceTypeProps {
  spaceType: SchoolSpaceType;
  inputError: boolean;
  setSpaceType: (spaceType: SchoolSpaceType) => void;
}

export const SelectSchoolSpaceType = ({
  spaceType,
  inputError,
  setSpaceType,
}: SchoolSpaceTypeProps) => {
  return (
    <>
      <Autocomplete
        options={Object.keys(schoolSpaceType)}
        getOptionLabel={(option) => schoolSpaceType[option] || ""}
        value={spaceType ?? ""}
        onChange={(_, newValue) =>
          setSpaceType(newValue as SchoolSpaceType)
        }
        renderInput={(params) => (
          <StyledTextField
            {...params}
            label="Тип закладу"
            variant="filled"
            error={inputError}
          />
        )}
      />
    </>
  );
};